import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=49a062b0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./CustomerDialog.vue?vue&type=script&lang=js&"
export * from "./CustomerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a062b0",
  null
  
)

export default component.exports